// components/skeletons/AgentsListSkeleton.tsx
// Placeholder for the agents table while the first load runs: toolbar + header
// row + agent rows. The page header stays on screen, so it is not drawn here.

import React from 'react';
import { G, C } from '../GlobalComponents/uiTokens';
import { Bone, SkeletonStyles } from './Bone';

const SHELL: React.CSSProperties = { background: G.shellBg, border: `1px solid ${G.shellBorder}`, borderRadius: '13px', padding: '4.6px' };
const INNER: React.CSSProperties = { background: C.white, border: `1px solid ${G.line}`, borderRadius: '9.2px', overflow: 'hidden' };

// agent · phone · city · commission · status · added · actions
const COLS: { w: string; grow?: boolean; cell: React.ReactNode }[] = [
  {
    w: '220px',
    grow: true,
    cell: (
      <div style={{ display: 'flex', alignItems: 'center', gap: '9px' }}>
        <Bone w={30} h={30} r="50%" />
        <div style={{ display: 'flex', flexDirection: 'column', gap: '5px', flex: 1 }}>
          <Bone w="60%" h={10} />
          <Bone w="40%" h={8} />
        </div>
      </div>
    ),
  },
  { w: '150px', cell: <Bone w="75%" h={10} /> },
  { w: '110px', cell: <Bone w="60%" h={10} /> },
  { w: '90px', cell: <Bone w={34} h={10} /> },
  { w: '80px', cell: <Bone w={32} h={18} r={20} /> },
  { w: '100px', cell: <Bone w="65%" h={10} /> },
  { w: '110px', cell: <div style={{ display: 'flex', gap: '6px', justifyContent: 'flex-end' }}><Bone w={26} h={26} r={7} /><Bone w={26} h={26} r={7} /></div> },
];

const AgentsListSkeleton: React.FC<{ rows?: number }> = ({ rows = 6 }) => (
  <div role="status" aria-busy="true" aria-label="Loading agents" style={SHELL}>
    <SkeletonStyles />
    <div style={INNER}>
      <div style={{ padding: '11px 13px', display: 'flex', alignItems: 'center', gap: '9px', flexWrap: 'wrap', borderBottom: `1px solid ${G.line}` }}>
        <Bone w={200} h={34} r={8} />
        <Bone w={150} h={34} r={8} />
      </div>
      <div style={{ overflowX: 'auto' }}>
        <div style={{ minWidth: '760px' }}>
          <div style={{ display: 'flex', alignItems: 'center', borderBottom: `1px solid ${G.line}` }}>
            {COLS.map((c, i) => (
              <div key={i} style={{ width: c.w, flex: c.grow ? 1 : undefined, flexShrink: 0, padding: '12px 13px' }}>
                <Bone w="50%" h={8} />
              </div>
            ))}
          </div>
          {Array.from({ length: rows }).map((_, r) => (
            <div key={r} style={{ display: 'flex', alignItems: 'center', borderBottom: r === rows - 1 ? 'none' : `1px solid ${G.softer}` }}>
              {COLS.map((c, i) => (
                <div key={i} style={{ width: c.w, flex: c.grow ? 1 : undefined, flexShrink: 0, padding: '11px 13px' }}>
                  {c.cell}
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
);

export default AgentsListSkeleton;
